import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * AdSenseManager – Handles dynamic injection of the AdSense script.
 *
 * AdSense Policy Compliance:
 * Ads must only appear on pages with substantial original publisher content.
 * The homepage ('/') is intentionally excluded because it is primarily a
 * marketing/navigation page (CTAs, service overview, contact form), which
 * Google classifies as "screens used for navigation or other behavioral purposes."
 *
 * Ads are only enabled on genuine content pages: service detail
 * pages, the about page, and the FAQ page.
 */

// Genuine content-rich routes where ads are permitted
const HIGH_VALUE_ROUTES = ['/service', '/about', '/faqs'];

// Utility pages — ads explicitly excluded
const EXCLUDED_ROUTES = ['/privacy', '/terms', '/disclaimer', '/contact'];

const AD_CLIENT = "ca-pub-5225157461642697";

const AdSenseManager = () => {
    const location = useLocation();

    useEffect(() => {
        const isExcluded = EXCLUDED_ROUTES.some(route => location.pathname.startsWith(route));
        const isHighValue = HIGH_VALUE_ROUTES.some(route => location.pathname.startsWith(route));

        if (isHighValue && !isExcluded) {
            if (!document.getElementById('adsense-script')) {
                const script = document.createElement('script');
                script.id = 'adsense-script';
                script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`;
                script.async = true;
                script.crossOrigin = "anonymous";
                document.head.appendChild(script);
            }
        }
    }, [location]);

    return null;
};

export default AdSenseManager;
